import { render, staticRenderFns } from "./OfferDetailBenefitSummary.vue?vue&type=template&id=38696aea"
import script from "./OfferDetailBenefitSummary.vue?vue&type=script&lang=js"
export * from "./OfferDetailBenefitSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports